import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.custom.background.area,
    border: `solid 1px ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadiusLarge,
    color: theme.palette.text.primary,

    '&.is-expanded': {
      alignItems: 'flex-start',
      '& .msg-collapse': {
        '&-icon': {
          marginTop: theme.spacing(1),
        },
        '&-text': {
          '&-container': {
            paddingBottom: theme.spacing(2),
          },
          '&-title': {
            minHeight: theme.spacing(9 / 2),
            margin: theme.spacing(1, 0),
          },
        },
      },
    },

    '&:not(.is-expanded)': {
      alignItems: 'center',
      '& .msg-collapse': {
        '&-text': {
          '&-title': {
            height: '100%',
          },
        },
      },
    },

    '&.alert': {
      '& .msg-collapse': {
        '&-icon, &-text-title': {
          color: theme.palette.custom.feedback.warning,
        },
      },
    },

    '&.error': {
      '& .msg-collapse': {
        '&-icon, &-text-title': {
          color: theme.palette.custom.feedback.negative,
        },
      },
    },

    '&.success': {
      '& .msg-collapse': {
        '&-icon, &-text-title': {
          color: theme.palette.custom.feedback.positive,
        },
      },
    },

    '& .msg-collapse': {
      '&-icon': {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(3),
      },
      '&-text': {
        '&-container': {
          flexGrow: 1,
          paddingRight: theme.spacing(1),
        },
        '&-title': {
          fontWeight: 'bold',
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
        },
        '&-message': {
          fontSize: '0.8rem',
        },
      },
      '&-btn-expand': {
        marginLeft: 'auto',
      },
    },
  },
}));

export default styles;
